import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleKeywordWhatWhere extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length >= 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.KEYWORD_WHAT) &&
			this.indexableFilters.some((_) => _.type === ParameterType.KEYWORD_WHERE)
		);
	}

	protected getPageTitle(): string {
		const keywordWhatValue = this.getFilterValue(ParameterType.KEYWORD_WHAT);
		const keywordWhereValue = this.getFilterValue(ParameterType.KEYWORD_WHERE);

		return `"${keywordWhatValue}" ${this.titlePortalType} in "${keywordWhereValue}"`;
	}
}
